"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_API_URLS = void 0;
var USER_API_URLS;
(function (USER_API_URLS) {
    USER_API_URLS["SIGNUP_USER"] = "/v2/user/signup";
    USER_API_URLS["SIGNUP_USER_METAMASK"] = "/v2/user/signup/metamask";
    USER_API_URLS["LOGIN_USER"] = "/v2/auth/login";
    USER_API_URLS["LOGOUT_USER"] = "/v2/auth/logout";
    USER_API_URLS["REFRESH"] = "v2/auth/refresh";
    USER_API_URLS["GET_USER_INFO"] = "/v2/user/get-info";
    USER_API_URLS["GET_METAMASK_USER_INFO"] = "/v2/user/get-metamask-info";
    USER_API_URLS["GET_USER_PROFILE"] = "/v2/user/get-profile";
    USER_API_URLS["SET_USER_ACCEPT_SM_TERMS"] = "/v2/user/accept-sm-terms";
    USER_API_URLS["GET_USERS_INFO_BY_IDS"] = "/v2/user/get-info-by-ids";
    USER_API_URLS["GET_USERS_INFO_BY_WALLETS"] = "/v2/user/get-info-by-wallets";
    USER_API_URLS["RESET_USER_PASSWORD_CONFIRM"] = "/v2/user/reset-password-confirmation/confirm";
    USER_API_URLS["RESET_USER_PASSWORD_SEND"] = "/v2/user/reset-password-confirmation/send";
    USER_API_URLS["DELETE_USER_ACCOUNT"] = "/v2/user/delete-account";
    USER_API_URLS["SEARCH_USERS"] = "/v2/user/search";
    USER_API_URLS["UPDATE_PROFILE"] = "/v2/user/update-profile";
    USER_API_URLS["CHANGE_USER_AVATAR"] = "/v2/user/change-avatar";
    USER_API_URLS["REMOVE_USER_AVATAR"] = "/v2/user/remove-avatar";
    USER_API_URLS["CHANGE_USER_EMAIL"] = "/v2/user/change-email";
    USER_API_URLS["CHANGE_USER_PASSWORD"] = "/v2/user/change-password";
    USER_API_URLS["CHANGE_USER_BANNER"] = "/v2/user/change-banner";
    USER_API_URLS["REMOVE_USER_BANNER"] = "/v2/user/remove-banner";
    USER_API_URLS["CONFIRM_USER_EMAIL"] = "/v2/user/email-confirmation/confirm";
    USER_API_URLS["SEND_USER_EMAIL"] = "/v2/user/email-confirmation/send";
    USER_API_URLS["VALIDATE_EMAIL"] = "/v2/user/validate-email-uniqueness";
    USER_API_URLS["VALIDATE_USER"] = "/v2/user/validate-user-uniqueness";
    USER_API_URLS["GET_USERS_HIGHLIGHTS"] = "/v2/user/highlights";
    USER_API_URLS["GET_USERS_BY_FILTER"] = "/v2/user/get-by-filter";
})(USER_API_URLS = exports.USER_API_URLS || (exports.USER_API_URLS = {}));
